import React, { FC } from 'react'
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Button } from '@components/Button'
import { ChevronRightIcon } from '@components/Icons'
import {
  ProductCardSectionTextColumn,
  ProductCardSectionContainer,
  ProductCardSectionIconCol,
  ProductCardSectionRowFlex,
  ProductCardSectionSubtitle,
  ProductCardSectionTitle,
  CardsWrapper,
  ProductCardSectionColumnFlex,
  getQuoteBtnStyles,
  learnMoreBtnStyles, LearnMoreButton, Divider,
} from './ProductCardSection.elements'

export type ProductCardProps = {
  isDivider: boolean;
  imageUrl: string
  title: string
  subtitle: string
  cardType: 'MEDSUP' | 'MEDADV' | 'LIFE_INSURANCE' | 'QUIZ' | 'AUTO_INSURANCE'
  learnMoreUrl: string
  buttonText: string
  onGetMyQuote: (cardType: 'MEDSUP' | 'MEDADV' | 'LIFE_INSURANCE' | 'QUIZ' | 'AUTO_INSURANCE') => void
  lessWidth: boolean
  moreWidth: boolean
}

type Props = {
  data: ProductCardProps[]
  onGetMyQuote: (cardType: 'MEDSUP' | 'MEDADV' | 'LIFE_INSURANCE' | 'QUIZ' | 'AUTO_INSURANCE') => void
}

const handleLearnMore = (url: string): void => {
  window.location.href = url
}

const ProductCard: FC<ProductCardProps> = ({
  imageUrl,
  title,
  subtitle,
  onGetMyQuote,
  cardType,
  learnMoreUrl,
  buttonText,
  lessWidth,
  moreWidth
}) => (
  <ProductCardSectionContainer>
    <ProductCardSectionColumnFlex>
      <ProductCardSectionIconCol imageUrl={imageUrl}/>
      <ProductCardSectionTextColumn>
        <ProductCardSectionTitle lessWidth={lessWidth} moreWidth={moreWidth} dangerouslySetInnerHTML={{ __html: title }} />
        <ProductCardSectionSubtitle lessWidth={false} moreWidth={false} dangerouslySetInnerHTML={{ __html: subtitle }} />
      </ProductCardSectionTextColumn>
    </ProductCardSectionColumnFlex>

    <CardsWrapper>
      <Button
        variant="green"
        fixedFont={true}
        onClick={() => onGetMyQuote(cardType)}
        css={getQuoteBtnStyles}
      >
        {buttonText}
      </Button>
      <LearnMoreButton
        onClick={() => handleLearnMore(learnMoreUrl)}
        variant="text"
        fixedFont={true}
        css={learnMoreBtnStyles}
        learnMoreUrl={learnMoreUrl}>
        LEARN MORE
        <ChevronRightIcon />
      </LearnMoreButton>
    </CardsWrapper>
  </ProductCardSectionContainer>
)

export const ProductCardSection: FC<Props> = ({
  data,
  onGetMyQuote,
}) => {
  return (
    <ProductCardSectionRowFlex>
      {data.map((field, idx) => !field.isDivider ? (
        <ProductCard
          key={field.imageUrl}
          {...field}
          onGetMyQuote={onGetMyQuote}
        />
      ) : <Divider key={idx} />)}
    </ProductCardSectionRowFlex>
  )
}
